import { asString, asNumber, loadedDefinedMap, isLoadedDefined } from "common/components/component-helpers";
import type { MapLocation, AppOther, AppEnvironment } from "common/components/types";
import { ActionSource, MapLocationKind } from "common/components/types";
import { Data } from "common/components/data";
import LocationMap from "../ui/smart/location-map/location-map";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";

export const MapMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[latitudeValue, longitudeValue, zoomLevel, onTap, addressValue]] = useForceValueProducers(
        getValueProducers,
        force,
        ctx
    );
    const { onClickWithCustomContext: onClickCB } = useOnClickFromAction(onTap, ActionSource.OpenMap, ctx, env);
    let location: MapLocation;
    let actionContext: unknown;

    if (isLoadedDefined(addressValue)) {
        const address = asString(addressValue);
        location = { kind: MapLocationKind.Address, address };
        actionContext = address;
    } else {
        const latitude = loadedDefinedMap(latitudeValue, asNumber);
        const longitude = loadedDefinedMap(longitudeValue, asNumber);
        if (latitude === undefined || longitude === undefined) return null;

        location = { kind: MapLocationKind.LatLong, latitude, longitude };
        actionContext = { latitude, longitude };
    }

    const zoom = loadedDefinedMap(zoomLevel, asNumber);
    const onClick =
        onClickCB !== undefined
            ? () => {
                  return onClickCB(Data.fromJSON<AppOther, AppEnvironment>(actionContext), undefined);
              }
            : undefined;
    return <LocationMap appEnvironment={env.appEnvironment} location={location} zoom={zoom} onClick={onClick} />;
};
